import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ChatCreateLoader } from './chatCreateInterface';
import { ChatCreateAggregate } from './chatCreateModel';

export function createChatCreateLoader(
    config: ReportingShellLoaderBaseConfig
): ChatCreateLoader {
    const {
        repository: { research, assistant },
    } = config;
    return {
        useLoad(context, props): ChatCreateAggregate {
            const threadQuery = assistant.thread.useFind(
                context,
                {
                    limit: 10,
                },
                {
                    suspense: true,
                }
            );
            assert(threadQuery.status === 'success', 'expected suspense');
            return {
                history: threadQuery.data,
            };
        },
    };
}
